/* src/app/common/mpos-forms/components/mpos-color/mpos-color.component.scss */
:host {
  display: flex;
}
:host ::ng-deep .btn-picker {
  margin-top: -12px !important;
  margin-left: -12px !important;
}
:host nz-form-item {
  display: flex;
  width: 100%;
}
/*# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsic3JjL2FwcC9jb21tb24vbXBvcy1mb3Jtcy9jb21wb25lbnRzL21wb3MtY29sb3IvbXBvcy1jb2xvci5jb21wb25lbnQuc2NzcyJdLAogICJzb3VyY2VzQ29udGVudCI6IFsiOmhvc3Qge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgOjpuZy1kZWVwIC5idG4tcGlja2VyIHtcbiAgICAgICAgbWFyZ2luLXRvcDogLTEycHggIWltcG9ydGFudDtcbiAgICAgICAgbWFyZ2luLWxlZnQ6IC0xMnB4ICFpbXBvcnRhbnQ7XG4gICAgfVxuICAgIG56LWZvcm0taXRlbSB7XG4gICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgIHdpZHRoOiAxMDAlO1xuICAgIH1cbn1cbiJdLAogICJtYXBwaW5ncyI6ICI7QUFBQTtBQUNJLFdBQUE7O0FBQ0EsTUFBQSxVQUFBLENBQUE7QUFDSSxjQUFBO0FBQ0EsZUFBQTs7QUFFSixNQUFBO0FBQ0ksV0FBQTtBQUNBLFNBQUE7OyIsCiAgIm5hbWVzIjogW10KfQo= */
